import ZendeskChatBot from '@patrianna-payments/zendesk'
import type { ZendeskChatBotProps } from '@patrianna-payments/zendesk'
import ZendeskMessaging from '@patrianna-payments/zendesk/messaging'
import { usePathname } from 'next/navigation'

import { useAppSelector } from 'src/store/hooks'
import {
  getLiveChatDepartmentsSelector,
  getLiveChatInfoSelector,
  getLiveChatSettingsSelector,
  getLiveChatUserInfoSelector,
} from 'store/modules/user/selectors'

const SNIPPET_KEY = process.env.ZENDESK_SNIPPET_KEY
const APP_ID = process.env.ZENDESK_APP_ID
const KEY_ID = process.env.ZENDESK_AUTH_KEY_ID

const SNIPPET_KEY_VIP = process.env.ZENDESK_SNIPPET_KEY_VIP
const KEY_ID_VIP = process.env.ZENDESK_AUTH_KEY_ID_VIP

function ZendeskChat() {
  const user = useAppSelector(getLiveChatUserInfoSelector)
  const liveChatInfo = useAppSelector(getLiveChatInfoSelector)
  const liveChatSettings = useAppSelector(getLiveChatSettingsSelector)
  const departments = useAppSelector(getLiveChatDepartmentsSelector)
  const pathname = usePathname()

  const isVip = liveChatSettings?.vip
  const isGamePage = pathname?.includes('/play') && !pathname?.includes('/play-')

  const isLiveChatVisible = liveChatSettings?.showLiveChat && !isGamePage
  const isMessagingVisible = isLiveChatVisible && (Boolean(KEY_ID) || Boolean(KEY_ID_VIP))
  const snippetKey = isVip ? SNIPPET_KEY_VIP : SNIPPET_KEY

  if (!APP_ID || !snippetKey) {
    return null
  }

  if (isMessagingVisible && !!user?.email?.length) {
    return (
      <ZendeskMessaging
        snippetKey={snippetKey}
        info={liveChatInfo}
        customerTag={liveChatSettings?.tag}
        additionalStyles={'#launcher { z-index: 1200 !important; }'}
      />
    )
  }

  const chatBotProps = {
    appId: APP_ID,
    snippetKey: SNIPPET_KEY,
    info: user,
  } as ZendeskChatBotProps

  if (isLiveChatVisible && !!user?.email?.length) {
    return <ZendeskChatBot {...chatBotProps} departments={departments} customerTag={liveChatSettings?.tag} />
  }

  return null
}

export default ZendeskChat
